import React from 'react';
import Banner from '@ingka/banner';
import { useGetV1ConfigQuery } from '@/redux/apis/frontend-api';

const MaintenanceBanner = () => {
  const { data, isLoading, isFetching, isError } = useGetV1ConfigQuery();

  if (
    isLoading ||
    isFetching ||
    isError ||
    !data ||
    !data.maintenanceStatus?.enabled
  )
    return null;

  const {
    maintenanceStatus: { text, dismissable, emergency },
  } = data;

  return (
    <Banner
      body={<span>{text}</span>}
      dismissable={dismissable}
      dismissHandler={() => {}}
      emergency={emergency}
    />
  );
};

export default MaintenanceBanner;
